import React, { useState } from "react"
import { useSelector } from "react-redux"
import { Grid, Image } from "semantic-ui-react"
import { Investissementbody } from "../../model/dto/body/investissement-body"
import { DefaultResponse, InvestResponse } from "../../model/dto/response"
import { AuthenticationState } from "../../model/state/authentication-state"
import { investmentService } from "../../services/investment-service"
import { ApplicationState } from "../../store"
import { FormErrorHeader } from "../generic/form-error-header"
import { SubmitButton } from "../generic/submit-button"

type Props = {
    montant?: number | string,
    projetId?: number,
    errorMessage?: string,
    isErrorDisplayed?: boolean,
    onSubmitImpossible?: (message: string) => void
}

export function CarteBancairePane({ montant, projetId, errorMessage, isErrorDisplayed, onSubmitImpossible }: Props) {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)

    const onSubmitSuccess = (response: InvestResponse): void => {
        if (response.IsTraitementOk) {
            window.location.href = response.RedirectURL!
        }
    }

    const onSubmitFailure = (response: DefaultResponse): void => {
        if(onSubmitImpossible) {
            onSubmitImpossible(response.Error ?? "")
        }
    }

    const body: Investissementbody = {
        IsPaiementCB: true,
        Montant: montant?.toString(),
    }

    return (
        <div>
            <FormErrorHeader message={errorMessage ?? ""} displayed={isErrorDisplayed ?? false} />
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <h3>Montant : {montant} €</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <p>
                            Toutes les transactions sont sécurisées via le protocole 3D Secure.
                            Assurez-vous qu'il soit actif sur votre carte bancaire.
                        </p>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                <div 
                  css={{
                    display : "flex", 
                    justifyContent: "space-around", 
                    flexDirection: "row", 
                    marginTop:"10px"
                  }}>
                        <Image
                          size="tiny"
                          src="/img/logos/powered-mangopay-2.png"
                          css={{marginInline : "8px"}}
                        />
                  </div>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column textAlign="center">
                        <SubmitButton
                            label="Procédez au paiement"
                            data={body}
                            action={() => investmentService.invest(projetId!, body, loginProps?.oauth)}
                            onActionSuccess={onSubmitSuccess}
                            onActionFailure={onSubmitFailure}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
}